import BillingModel from "../../../../../types/billing-model";

export type BillingsOrderRailyTaxiRecalculateContractTaxiCompany = {
  companyName: string;
};

export type BillingsOrderRailyTaxiRecalculateContract = {
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiCorporation: BillingsOrderRailyTaxiRecalculateContractTaxiCompany;
};

export type BillingsOrderRailyTaxiRecalculateBillingNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventUuid?: string;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderRailyTaxiRecalculateCargoOrder = {
  humanId: number;
};

export enum BillingsOrderRailyTaxiRecalculatePenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiRecalculateBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

type BillingsOrderRailyTaxiRecalculate = {
  contract: BillingsOrderRailyTaxiRecalculateContract;
  billingNodes: BillingsOrderRailyTaxiRecalculateBillingNode[];
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderRailyTaxiRecalculateCargoOrder;
  planEntryUuid: string;
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiRecalculatePenaltyType;
  bonusType?: BillingsOrderRailyTaxiRecalculateBonusType;
  date: Date;
};

export default BillingsOrderRailyTaxiRecalculate;
